/**
 * Impressum nach § 5 TMG.
 * Frei zugänglich (kein Login), Footer-Link auf allen Seiten.
 *
 * Quelle: https://devhive.de/impressum.html — bei Änderungen dort
 * bitte hier nachziehen, damit die Inhalte synchron bleiben.
 */

import { Link } from 'react-router-dom';

export default function ImpressumPage() {
  return (
    <div className="max-w-2xl mx-auto space-y-6 pb-8 text-slate-200">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">Impressum</h2>
        <Link to="/" className="text-xs text-slate-400 hover:text-slate-200 underline">
          ← zurück
        </Link>
      </div>

      <section>
        <h3 className="text-sm uppercase tracking-wider text-slate-400 mb-2">
          Angaben gemäß § 5 TMG
        </h3>
        <p className="text-sm">
          DevHive Network<br />
          Tobias Peters<br />
          c/o Online-Impressum.de #53822<br />
          Europaring 90<br />
          53757 Sankt Augustin<br />
          Deutschland
        </p>
      </section>

      <section>
        <h3 className="text-sm uppercase tracking-wider text-slate-400 mb-2">Kontakt</h3>
        <ul className="text-sm space-y-1">
          <li>
            E-Mail:{' '}
            <a
              href="mailto:admin@devhive.de"
              className="text-brand hover:underline"
            >
              admin@devhive.de
            </a>
          </li>
          <li>
            Discord:{' '}
            <a
              href="https://discord.gg/rSgWay92Mq"
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand hover:underline"
            >
              DevHive Network
            </a>
          </li>
        </ul>
      </section>

      <section>
        <h3 className="text-sm uppercase tracking-wider text-slate-400 mb-2">
          Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
        </h3>
        <p className="text-sm">
          DevHive Network<br />
          Tobias Peters<br />
          c/o Online-Impressum.de #53822<br />
          Europaring 90<br />
          53757 Sankt Augustin<br />
          Deutschland<br />
          E-Mail:{' '}
          <a href="mailto:admin@devhive.de" className="text-brand hover:underline">
            admin@devhive.de
          </a>
        </p>
      </section>

      <section>
        <h3 className="text-sm uppercase tracking-wider text-slate-400 mb-2">
          Haftungsausschluss
        </h3>

        <h4 className="text-base font-medium mt-3 mb-1">Haftung für Inhalte</h4>
        <p className="text-sm text-slate-300">
          Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die
          Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch
          keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG
          für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
          verantwortlich.
        </p>

        <h4 className="text-base font-medium mt-3 mb-1">Haftung für Links</h4>
        <p className="text-sm text-slate-300">
          Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte
          wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch
          keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der
          jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
        </p>

        <h4 className="text-base font-medium mt-3 mb-1">Urheberrecht</h4>
        <p className="text-sm text-slate-300">
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
          unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
          Verbreitung und jede Art der Verwertung außerhalb der Grenzen des
          Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors
          bzw. Erstellers.
        </p>
      </section>

      <p className="text-xs text-slate-500">Stand: Februar 2026</p>
    </div>
  );
}
